export default "__VITE_ASSET__C9bOu8Vy__"